<template>
    <div class="usersList">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>查询用户</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table class="user-list-table" :data="userList" stripe border>
            <el-table-column label="用户ID" align='center' width="100px">
                <template scope="scope">
                    <span>{{scope.row.userId}}</span>
                </template>
            </el-table-column>
            <el-table-column label="邮箱" align='center'>
                <template scope="scope">
                    <span>{{scope.row.accountEmail}}</span>
                </template>
            </el-table-column>
            <el-table-column label="姓名" align='center' width="120px">
                <template scope="scope">
                    <span>{{scope.row.userName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="权限名称" align='center'  width="200px">
                <template scope="scope">
                    <span>{{scope.row.permissionsName}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align='center'>
                <template scope="scope">
                    <!--<el-button size="small" type="info" @click="">编辑</el-button>-->
                    <el-button size="small" type="warning" @click="changePassword(userInfo.userId, scope.row.userId)">修改密码</el-button>
                    <el-button size="small" type="danger" @click="deleteUser(scope.row.userId)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页器-->
        <!--<el-pagination class="page-control" layout="prev, pager, next" :total="userListLength"></el-pagination>-->
        <!--end-->
        <el-dialog title="修改密码" v-model="config.changePwdDialog.visible" :lock-scroll="true" @close="clearPwdFormData">
            <el-form :model="changePwdForm" ref="form">
                <el-form-item label="管理员密码" :label-width="config.changePwdDialog.formLabelWidth">
                    <el-input type="password" v-model="changePwdForm.managerPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" :label-width="config.changePwdDialog.formLabelWidth">
                    <el-input type="password" v-model="changePwdForm.newPassword" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="config.changePwdDialog.formLabelWidth">
                    <el-input type="password" v-model="changePwdForm.confirmPassword" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="config.changePwdDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="setPassword">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "usersList",
    data() {
        return {
            userList: null,
            userListLength: 0,
            changePwdForm: {
                managerUserId: null,
                managerPassword: null,
                editUserId: null,
                newPassword: null,
                confirmPassword: null
            },
            config: {
                contentBoxWidth: 0,
                changePwdDialog: {
                    visible: false,
                    formLabelWidth: '120px'
                }
            }
        };
    },
    mounted(){
        this._init();
    },
    computed: {
        ...mapGetters({
            userInfo: 'getUserInfo'
        })
    },
    methods: {
        _getUserList() {
            this.$http.get(CONFIG.HOST + "/users/list" + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.userList = result.data;
                    this.userListLength = this.userList.length || 0;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response)=>{
                console.log(response);
            });
        },
        _confirmMessage(message, success = ()=>{}, cancel = ()=>{}) {  
            return this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });       
        },
        deleteUser(userId) {
            this._confirmMessage('是否确定删除userId=' + userId + '的用户？').then(()=>{
                if (userId < 0) {
                    this.$notify.error({
                        message: '【营销平台】userId=' + userId + '的用户不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/users/deleteUser/' + userId).then((response)=>{
                    let result = response.body;
                    if (result && result.status === 1) {
                        this._getUserList();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                },(response)=>{
                    console.log(response);
                });
            }).catch(()=>{});
        },
        changePassword(managerUserId, editUserId){
            if (managerUserId < 0 || editUserId < 0) {
                this.$notify.error({
                    message: '【营销平台】userId=' + editUserId + '的用户不存在或管理员信息错误'
                });
                return;
            }
            this.changePwdForm.managerUserId = managerUserId;
            this.changePwdForm.editUserId = editUserId;
            this.config.changePwdDialog.visible = true;
        },
        setPassword(){
            if (!this.changePwdForm.managerPassword || !this.changePwdForm.newPassword || this.changePwdForm.newPassword !== this.changePwdForm.confirmPassword) {
                this.$notify.error({
                    message: '输入密码为空或输入密码不一致'
                });
                return;
            }
            let pwdData = {
                userId: this.changePwdForm.editUserId,
                password: md5(this.changePwdForm.newPassword),
                systemUserId: this.changePwdForm.managerUserId,
                systemPassword: md5(this.changePwdForm.managerPassword)
            };
            this.$http.put(CONFIG.HOST + '/users/updataPasswordBySystem', pwdData).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】userId=' + this.changePwdForm.editUserId + '的用户密码修改成功'
                    });
                    this.config.changePwdDialog.visible = false;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        clearPwdFormData(){
            this.changePwdForm.managerUserId = null;
            this.changePwdForm.managerPassword = null;
            this.changePwdForm.editUserId = null;
            this.changePwdForm.newPassword = null;
            this.changePwdForm.confirmPassword = null;
        },
        _init() {
            this._getUserList();
        }
    }
};
</script>
<style lang="less">
    .usersList{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .user-list-table{
            min-width: 980px;
        }
        .page-control{
            margin: 20px auto 0 auto;
        }
    }  
</style>


// WEBPACK FOOTER //
// List.vue?7c81ae26